import { Box, Button, Group, Stack, Text, useMantineTheme } from '@mantine/core'
import { TDownlinkPresetListItem } from 'api/loraDevices/getDownlinkPresets'
import { downlinkInsertModes } from 'data/downlinkInsertMode'
import { CSSProperties, memo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import classes from './DownlinkPresetItem.module.css'

export const DownlinkPresetItem = memo((item: TDownlinkPresetListItem) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const { setValue } = useFormContext()
  const itemStyle = {
    '--downlink-preset-border-color':
      theme.colorScheme === 'light'
        ? theme.colors.gray[4]
        : theme.colors.dark[4],
  } as CSSProperties

  const onClick = () => {
    const presetItem = {
      type: item.insertMode.toString(),
      fPort: item.port,
      payload: item.payload,
    }

    Object.entries(presetItem).forEach(([key, value]) => setValue(key, value))
  }

  return (
    <Box
      className={classes.item}
      style={itemStyle}
      key={item.id}
      py="sm"
      px="lg"
    >
      <Group justify="space-between" gap={'xl'}>
        <Stack gap={0}>
          <Text size="sm">{item.title}</Text>
          <Group>
            <Text size="xs" style={{ fontFamily: 'monospace' }}>
              {item.payload}
            </Text>
            <Text size="xs">Port: {item.port}</Text>
            <Text size="xs">
              {t('generic.type')}:{' '}
              {downlinkInsertModes(t).get(item.insertMode)?.label}
            </Text>
          </Group>
        </Stack>
        <Button onClick={onClick} size="compact-sm">
          Use this preset
        </Button>
      </Group>
    </Box>
  )
})
